<p-card styleClass="very-compact-card p-3">
  <div class="flex align-items-center gap-2">
    <h3 class="m-0">История</h3>
    <crm-button-show-and-hide
      [isShow]="exclusionHistoryInfo.showHistory"
      (isShowChange)="isShowChange($event)"></crm-button-show-and-hide>
  </div>

  @if (exclusionHistoryInfo.showHistory) {
    <div class="mt-3">
      @if (!exclusionHistoryInfo.loading) {
        @if (exclusionHistoryInfo.items; as historyItems) {
          @if (historyItems?.length) {
            <div
              class="mt-2 max-h-29rem overflow-y-auto overflow-x-hidden"
              (scroll)="onScrollEndHistory($any($event.target))">
              <p-timeline
                [value]="historyItems | orderBy: '-date:date'"
                styleClass="history-timeline mt-3">
                <ng-template
                  pTemplate="content"
                  let-event>
                  @if (toHistory(event); as event) {
                    <div class="flex -mt-2 mb-4">
                      <crm-user-avatar [user]="event.user"></crm-user-avatar>
                      <div class="w-full ml-3">
                        <div class="font-medium">{{ event.user?.profile?.name || 'ФРМ' }}</div>
                        <div class="text-400 text-sm">{{ event.created | date: 'dd.MM.yyyy HH:mm' }}</div>
                        <div class="mt-2">
                          <span [innerHTML]="event?.name"></span>
                          @if (event.oldValue) {
                            <span> c "{{ event.oldValue }}"</span>
                          }
                          @if (event.newValue) {
                            <span> на "{{ event.newValue }}"</span>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </ng-template>
              </p-timeline>

              @if (exclusionHistoryInfo.paginationLoading) {
                <div class="text-center">
                  <p-progressSpinner
                    [style]="{
                      width: '50px',
                      height: '50px'
                    }"></p-progressSpinner>
                </div>
              }
            </div>
          } @else {
            <p class="text-xl font-medium mt-2">Нет данных</p>
          }
        }
      }

      @if (exclusionHistoryInfo.loading) {
        <crm-spinner
          top="mt-4 pb-0 mb-4 pb-4"></crm-spinner>
      }
    </div>
  }
</p-card>
